import { useDispatch } from 'react-redux';
import { Col, Alert, Spinner, CardBody, Card, CardHeader, Row } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { createSelector } from 'reselect';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { getWarehouseByEstablishment, getWarehouseItemList, synchronizeWarehouseItems, getWarehouseItemListQuery } from '../../../../slices/thunks';
import { Link } from 'react-router-dom';
// import AddEditItemModal from './Add_Edit/AddEditItem';
// import DeleteItemModal from './Delete/DeleteItem';
import { ODataGrid } from '../../../../Components/OElements/ODataGrid';
import ReceptionItemModal from '../../Item/Modals/ReceptionItemModal';
import DeleteItemModal from '../../Item/Delete/DeleteItem';
import AddEditItemModal from '../../Item/Add_Edit/AddEditItem';
import { useUser } from '../../../../Components/Hooks/useUserHooks';
// import ReceptionItemModal from './Modals/ReceptionItemModal';
import { Tooltip } from '@mantine/core';

const ItemList = ({ establishment_id }) => {
    const dispatch = useDispatch();
    const { user } = useUser();

    const selectorItems = createSelector(
        state => state.WarehouseItems,
        data => ({
            dataList: data.warehouseItemList,
            isLoadingList: data.isLoadingList,
            isItemSuccess: data.isItemSuccess,
            error: data.error,
            isAdding: data.isAdding,
            isAdded: data.isAdded,
            isAddError: data.isAddError,
            isUpdating: data.isUpdating,
            isUpdated: data.isUpdated,
            isUpdateError: data.isUpdateError,
            isDeleting: data.isDeleting,
            isDeleted: data.isDeleted,
            isDeleteError: data.isDeleteError,
        })
    );

    const { dataList, isLoadingList } = useSelector(selectorItems);

    const selectorWarehouse = createSelector(
        state => state.Warehouses,
        data => ({
            itemWarehouse: data.itemWarehouse,
            itemWarehouseDetail: data.itemWarehouseDetail,
            isLoadingWarehouseList: data.isLoadingWarehouseList,
        })
    );

    const { itemWarehouse, itemWarehouseDetail, isLoadingWarehouseList } = useSelector(selectorWarehouse);


    useEffect(() => {
        const fetchData = async () => {
            const warehouse = await dispatch(getWarehouseByEstablishment(establishment_id));
            dispatch(getWarehouseItemList({ establishment_id: establishment_id }));
        };
        fetchData();
    }, [establishment_id]);


    const [dataItem, setDataItem] = useState({});
    const [isEdit, setIsEdit] = useState(false);

    // Delete Item
    const [modal, setModal] = useState(false);
    const [modalDelete, setModalDelete] = useState(false);
    const [modalReception, setModalReception] = useState(false);
    //Tab
    const [activeTab, setActiveTab] = useState('1');
    const toggleTab = tab => {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    };

    function handleToggleModal() {
        setModal(!modal);
        toggleTab('1');
        // validation.resetForm();
    }

    function handleToggleModalDelete() {
        setModalDelete(!modalDelete);
    }

    function handleToggleModalReception() {
        setModalReception(!modalReception);
        toggleTab('1');
        // validation.resetForm();
    }

    // Delete Data
    const handleClickDelete = data => {
        setDataItem(data);
        setModalDelete(true);
    };

    // Update Data
    const handleClickEdit = data => {
        setDataItem(data);
        handleToggleModal();
    };

    function synchronize() {
        dispatch(synchronizeWarehouseItems({ warehouse_id: itemWarehouse._id, group_code: '103-104' }));
    }


    useEffect(() => {
        dispatch(getWarehouseItemListQuery({ establishment_id: establishment_id }));
    }, [itemWarehouseDetail]);

    const columns = useMemo(
        () => [
            { header: 'Codigo SAP', accessorKey: 'code_sap', size: 'auto' },
            { header: 'Categoría', accessorKey: 'warehouse_category.name', size: 'auto' },
            { header: 'Unidad', accessorKey: 'unit_measurement.name', size: 'auto' },
            { header: 'Nombre', accessorKey: 'name', size: 'auto' },
            { header: 'Precio USD', accessorKey: 'price', size: 'auto', summary: true, type: 'separator' },
            { header: 'Cantidad', accessorKey: 'quantity', size: 'auto', summary: true, type: 'separator' },
            { header: 'Reservado', accessorKey: 'reserved', size: 'auto', summary: true, type: 'separator' },
            { header: 'Disponible', accessorKey: 'available', size: 'auto', summary: true, type: 'separator' },
        ],
        [handleClickEdit]
    );

    return (
        <React.Fragment>
            <Row>
                <Col lg={12}>
                    <Card>
                        {/* <CardHeader className='border-0 pb-0'>
                            <div className='d-flex align-items-end justify-content-end'>
                                <div className='flex-shrink-0'>
                                    <div className='d-flex flex-wrap gap-2'>
                                        {['BDG', 'ABS', 'ADM'].includes(user.role_code) && (
                                            <button className='btn btn-label btn-primary' disabled={isLoadingWarehouseList} onClick={() => { synchronize(); }}>
                                                {isLoadingWarehouseList ? (<i className="label-icon"><Spinner size='sm' /></i>) : <i className="icon-refresh-cw label-icon"></i>} Sincronizar con SAP
                                            </button>
                                        )}
                                        {['BDG', 'ABS', 'ADM'].includes(user.role_code) && (
                                            <button className='btn btn-label btn-primary' onClick={() => { setIsEdit(false); setDataItem({}); handleToggleModal(); }}>
                                                <i className={`${Icons.plus} label-icon`}></i>{' '}
                                                Agregar Item
                                            </button>
                                        )}

                                        <button className='btn btn-label btn-primary' onClick={() => { handleToggleModalReception(); }}>
                                            <i className={`${Icons.plus} label-icon`}></i>{' '}
                                            Recepcionar Items
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </CardHeader> */}
                        <CardBody>
                            <ODataGrid
								columns={columns}
								data={dataList || []}
								isLoadingData={isLoadingList}
								nameFile={'items'}
                                customToolbarActions={({ table }) => (
                                    <div className="d-flex justify-content-start gap-2">
                                        <Tooltip label='Sincronizar con SAP' position='top' withinPortal>
                                            <button className='btn d-flex align-items-center btn-tooltip-hover gap-1' disabled={isLoadingWarehouseList} onClick={() => { synchronize(); }}>
                                                {isLoadingWarehouseList ? (<i className="icon-tooltop-size"><Spinner size='sm' /></i>) : <i className={`${Icons.refresh} icon-tooltop-size`}></i>} Sincronizar
                                            </button>
                                        </Tooltip>
                                        <Tooltip label='Agregar Item' position='top' withinPortal>
                                            <button className='btn d-flex align-items-center btn-tooltip-hover gap-1' onClick={() => { setIsEdit(false); setDataItem({}); handleToggleModal(); }}>
                                                <i className='icon-plus icon-tooltop-size'></i>{' '}
                                                Agregar
                                            </button>
                                        </Tooltip>
                                        <Tooltip label='Recepcionar Items' position='top' withinPortal>
                                            <button className='btn d-flex align-items-center btn-tooltip-hover gap-1' onClick={() => { handleToggleModalReception(); }}>
                                                <i className='icon-plus icon-tooltop-size'></i>{' '}
                                                Recepcionar
                                            </button>
                                        </Tooltip>
                                    </div>
                                )}

							/>
                            {/* <ODataGrid
                                key={'odatagrid_item_list' + refreshTimestamp} 
                                columns={columns}
                                getDataFunc={getWarehouseItemListQuery}
                                queryPopulate={[
                                    'warehouse',
                                    'warehouse_category',
                                    'warehouse_group',
                                    'unit_measurement',	
                                ]}
                                baseFilters={{
                                    warehouse: {
                                        establishment_id:{
                                            $eq: establishment_id,
                                        }
                                    },
                                }}
                                remoteOperations={{
                                    pagination: true,
                                    sorting: true,
                                    filtering: true,
                                }}
                                nameFile={'items'}
                            /> */}
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <AddEditItemModal
				dataItem={dataItem}
				isEdit={isEdit}
				isOpen={modal}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>
			<DeleteItemModal
				dataItem={dataItem}
				isOpen={modalDelete}
				handlerToggleModal={handleToggleModalDelete}
			/>
            <ReceptionItemModal
				establishmentId={establishment_id}
				isOpen={modalReception}
				handleToggleModal={handleToggleModalReception}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>
        </React.Fragment>
    );
};

export default ItemList;